import React, { useState, useEffect, useRef } from "react";
import { localAttributes } from "assets/constants";
import { KeyValuePair, objectTypeProps } from "types";
import "instantsearch.css/themes/satellite.css";
import styles from "./SearchOuterServices.module.scss";
import Text from "components/text/Text";
import { getAllClassNames, isDev, setParams } from "helpers";
import strings from "assets/strings";
import { visitHoursOptions } from "assets/constants";
import { ArrowLeft, ArrowUp } from "assets/icons";
import Button from "components/buttons/button/Button";
import Popup from "components/popup/Popup";
import { CustomLocalSearchInput } from "components/inputs/customLocalSearchInput/CustomLocalSearchInput";
import { CustomCheckboxesLocal } from "components/buttons/customCheckboxesLocal/CustomCheckboxesLocal";
import settings from "assets/mergeSettings";
import { AlertPopup } from "components/popup/alertPopup/AlertPopup";
import RadioButton from "components/radioButton/RadioButton";
import TextInput from "components/inputs/textInput/TextInput";
import { BubbleIcon } from "components/bubbleIcon/BubbleIcon";
//import { DropdownCheckboxes } from "components/dropdownCheckboxes/DropdownCheckboxes";

export function SearchOuterServices(props: objectTypeProps) {
  const { objectType } = props;
  const [expanded, setExpanded] = useState(false);
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [medicalServices, setMedicalServices] = useState<string>('');
  const [workHours, setWorkHours] = useState<string[]>([])
  const [serviceCode, setServiceCode] = useState<string | number>('')
  const [selectedFieldOfService, setSelectedFieldOfService] = useState<string>(strings.searchOuterServices.fieldOfService)
  const [infoPopup, setInfoPopup] = useState('')
  const [switchSelected, setSwitchSelected] = useState(false)
  const divExpandRef = useRef<HTMLDivElement>(null);
  const submitButtonRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
 
  const medicalServicesSearchRef = useRef<any>(null);
  

  const handleSelectedFieldOfService = (value: string) => {
    setSelectedFieldOfService(value)
    setMedicalServices('')
    setServiceCode('')
    medicalServicesSearchRef.current?.resetBubbles();
    if (value === strings.searchOuterServices.fieldOfService) setSwitchSelected(false)
    else setSwitchSelected(true)
  }

  useEffect(() => {
    if (divExpandRef.current && expanded) {
      const firstInput = divExpandRef.current.querySelector('input');
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [expanded]);

  const onSubmit = (event: any) => {
    event.preventDefault();

    if (objectType == 10 && selectedFieldOfService == strings.searchOuterServices.fieldOfService && !medicalServices) {
      handleToggleVisibility()
      setInfoPopup(strings.errorMessages.requiredFieldOfService)
    }
    else if (objectType == 10 && selectedFieldOfService == strings.searchOuterServices.serviceCode && !serviceCode && !serviceCode.toString().length) {
      handleToggleVisibility()
      setInfoPopup(strings.errorMessages.requiredServiceCode)
    }
    else if (objectType != 1 && objectType != 10 && !city && !name) {
      handleToggleVisibility()
    }

    else {
      const formData: KeyValuePair[] = [
        { key: `${[localAttributes.localOuterServiceName]}`, value: name },
        { key: `${[localAttributes.localMedicalServicesApiKey]}`, value: medicalServices },
        { key: `${[localAttributes.localCityCodeFieldName]}`, value: city },
        { key: `${[localAttributes.localWorkHoursFieldName]}`, value: workHours.join(',') },
        { key: `${[localAttributes.localServiceCodeFieldName]}`, value: String(serviceCode) },
      ];

      if (city && city.split(',').length == 1) {
        const cities = localStorage.getItem("cities");
        const citiesArr = cities && JSON.parse(cities);
        const locLat = citiesArr.find((c: any) => c.cityCode === city)?.latitude;
        const locLLong = citiesArr.find((c: any) => c.cityCode === city)?.longitude;
        formData.push({ key: `${[localAttributes.localLocFieldName]}`, value: `${locLat},${locLLong}` }, { key: `${[localAttributes.localRadiusFieldName]}`, value: "10000" });
      }
      window.location.href = `${settings.outerServiceSearchResults}?${setParams(formData)}`;
    }
  };

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle('show');
    }
  };

  useEffect(() => {
    const handlePopState = () => {
      // Your logic here
      setMedicalServices('');
      setWorkHours([]);
      setCity('');
      setName('');
      setServiceCode('');
      setSelectedFieldOfService(strings.searchOuterServices.fieldOfService);
    };

    // Add event listener on mount
    window.addEventListener('popstate', handlePopState);

    // Remove event listener on cleanup
    return () => window.removeEventListener('popstate', handlePopState);
  }, []); // Empty dependency array ensures this runs once on mount

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      // if (submitButtonRef.current) {
      //   submitButtonRef.current.focus();
      // }
    }
  };

  // Rest of your component logic
  return (
    <div
      className={getAllClassNames([
        "ais-InstantSearch",
        isDev() && styles.devContainer,
      ])}
    >

      <div className={styles.container}>
        <div
          className={getAllClassNames([
            styles.searchDiv,
            expanded && styles.noBorderBottom,
          ])}
        >
          <div className={styles.searchDivWrapper}>
            <Text
              className={styles.serachTitle}
              text={strings.searchOuterServices.searchOuterServiceInstruction} />

            <div className={styles.searchFieldsWrapper}>
              <div className={styles.divFlex}>
                <CustomLocalSearchInput
                  forceReset
                  isPopup
                  popupProps={{
                    title: strings.searchOuterServices.serviceProviderName,
                    subTitle: strings.searchOuterServices.canChooseFieldOfService,
                    placeholder: '',
                    keyToNormalize: 'name',
                    labelToNormalize: 'name',
                    //filterBy: 'medicalFieldName',
                    onSubmit: () => { },
                  }}
                  enableFreeText
                  enableNotAutoComplete
                  attribute={localAttributes.localDoctorNamesApiKey}
                  title={strings.searchOuterServices.serviceProviderName}
                  queryParams={[{ key: 'objectType', value: objectType }]}
                  onChange={(value: string) => setName(value)}
                  onReset={() => setName('')}
                />
              </div>
              <div className={styles.divFlex}>
                <RadioButton
                  ariaLabel={strings.searchOuterServices.fieldOfService}
                  name="fieldOfService"
                  value={strings.searchOuterServices.fieldOfService}
                  isSelected={selectedFieldOfService === strings.searchOuterServices.fieldOfService}
                  onSelecteRadio={(value: string) => handleSelectedFieldOfService(value)}
                />

                <CustomLocalSearchInput
                  ref={medicalServicesSearchRef}
                  forceReset
                  isPopup
                  popupProps={{
                    title: strings.searchOuterServices.fieldOfService,
                    subTitle: strings.searchOuterServices.canChooseFieldOfService,
                    placeholder: '',
                    keyToNormalize: localAttributes.localMedicalFieldName,
                    labelToNormalize: localAttributes.localMedicalFieldName,
                    //filterBy: 'medicalFieldName',
                    onSubmit: () => { },
                  }}
                  enableFreeText ={!switchSelected}
                  enableNotAutoComplete
                  attribute={localAttributes.localMedicalApiKey}
                  title={strings.searchOuterServices.fieldOfService}
                  queryParams={[{ key: 'objectType', value: objectType }]}
                  onChange={(value: string) => setMedicalServices(value)}
                  onReset={() => setName('')}
                />

                {/* <DropdownCheckboxes
                  isSwitchSelected={switchSelected}
                  title={strings.searchOuterServices.fieldOfService}
                  objectType='10'
                  disabled={selectedFieldOfService === strings.searchOuterServices.serviceCode}
                  className={styles.dropdownCheckboxes}
                  attribute={localAttributes.localMedicalApiKey}
                  keyToNormalize={localAttributes.localMedicalFieldName}
                  labelToNormalize={localAttributes.localMedicalFieldName}
                  dropDownClass={styles.dropDownClass}
                  setQueryParams={(values: string[]) => setMedicalServices(values)}
                /> */}
              </div>
              <div className={styles.divFlex}>
                <div className={getAllClassNames([styles.labelWrapper])}>
                  <RadioButton
                    ariaLabel={strings.searchOuterServices.serviceCode}
                    //name="serviceCode"
                    name="fieldOfService"
                    label={strings.searchOuterServices.serviceCode}
                    value={strings.searchOuterServices.serviceCode}
                    className={styles.label}
                    isSelected={selectedFieldOfService === strings.searchOuterServices.serviceCode}
                    onSelecteRadio={(value: string) => handleSelectedFieldOfService(value)}
                  />
                  {(strings.searchOuterServices.tooltipTitle || strings.searchOuterServices.tooltipContent) && <BubbleIcon
                    isPopup
                    popupTitle={strings.searchOuterServices.tooltipTitle}
                    popupContent={strings.searchOuterServices.tooltipContent}
                    //contentClassName={styles.contentClassName}
                    text={strings.globalStrings.whatIsThis}
                    info={strings.searchOuterServices.serviceCodeInfo}
                    className={styles.bubbleIcon}
                  />}
                </div>
                <TextInput
                  ariaLabel={strings.searchOuterServices.serviceCode}
                  typedValue={serviceCode.toString()}
                  onChange={(value) => setServiceCode(value)}
                  onKeyDown={handleKeyDown}
                  isDisabled={selectedFieldOfService === strings.searchOuterServices.fieldOfService} />
              </div>
              <div className={styles.divFlex}>
                <CustomLocalSearchInput
                  forceReset
                  multiSelect
                  isPopup
                  popupProps={{
                    title: strings.globalStrings.chooseCity,
                    subTitle: strings.globalStrings.canChooseCity,
                    placeholder: strings.globalStrings.searchCity,
                    keyToNormalize: 'cityCode',
                    labelToNormalize: 'city',
                    //filterBy: 'city',
                    onSubmit: () => { },
                  }}
                  placeholder={strings.globalStrings.cityPlaceholder}
                  enableFreeText
                  attribute={localAttributes.localCitiesApiKey}
                  title={strings.globalStrings.city}
                  queryParams={[{ key: 'objectType', value: objectType }]}
                  onChange={(value: string) => { setCity(value) }}
                  onReset={() => setCity('')}
                />
              </div>
            </div>

          </div>

        </div>


        {expanded && (
          <div className={styles.divExpand} ref={divExpandRef}>
            <CustomCheckboxesLocal
              onSetSelected={(selectedData: string[]) => setWorkHours(selectedData)}
              title={strings.globalStrings.visitHours}
              options={visitHoursOptions}
              selectedCheckboxes={workHours}
            />
          </div>
        )}
        {settings.showAdvanceSearch ?
          <div className={styles.divBottom}>
            <div>
              <Text
                onClick={() => setExpanded(!expanded)}
                className={styles.textAdvance}
                text={expanded ? strings.globalStrings.closeAdvancedSearch : strings.globalStrings.advanceSearch}
              />
              {expanded ? (
                <ArrowUp className={styles.icon} />
              ) : (
                <ArrowLeft className={styles.icon} />
              )}

            </div>
            <Button
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div> :
          <div className={styles.divBottomNoAavanced}>
            <Button
              ref={submitButtonRef}
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div>
        }
      </div>
      {
        <Popup        
          ref={popupRef}
          onClose={() => handleToggleVisibility()}
          height={284}
          width={550}
          style={{ paddingBottom: '0px' }}
        >
          <AlertPopup
            title={strings.errorMessages.notice}
            subTitle={objectType == 10 ? infoPopup : strings.errorMessages.requiredProperties}
            showButton
            buttonText={strings.globalStrings.close}
            onClose={() => handleToggleVisibility()}
          ></AlertPopup>
        </Popup>
      }
    </div>
  );
}

export default SearchOuterServices;
